/**
 * Location utilities for projectL
 * - formatLocationLabel: returns human-readable label for location objects or coords
 * - getCoordsFromLocation: returns {lat,lng} if available
 */

export function formatLocationLabel(loc) {
  if (!loc) return null;

  // If already a string, assume it's a label/address
  if (typeof loc === 'string') return loc;

  // If object with label or address fields
  if (loc.label) return loc.label;
  if (loc.address)
    return typeof loc.address === 'string' ? loc.address : JSON.stringify(loc.address);

  // If lat/lng available, format coord string
  const lat = loc.lat || loc.latitude;
  const lng = loc.lng || loc.longitude || loc.lon;
  if (lat !== undefined && lng !== undefined) {
    return `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}`;
  }

  // Fallback to JSON string
  try {
    return JSON.stringify(loc);
  } catch (e) {
    return null;
  }
}

export function getCoordsFromLocation(loc) {
  if (!loc) return null;
  if (typeof loc === 'string') return null;
  const lat = loc.lat || loc.latitude;
  const lng = loc.lng || loc.longitude || loc.lon;
  if (lat !== undefined && lng !== undefined) return { lat: Number(lat), lng: Number(lng) };
  return null;
}
